const key = 'ce19295998483004020f801b55f90c09Tz03NjkwMCxFPTE3MjkyNzQzNzkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';
export default key;
//# sourceMappingURL=muiProLicenseKey.js.map